import unifapImage from "./unifapImage";

// import momentjs from "moment";
let pdfMake = require("pdfmake/build/pdfmake");
let pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var htmlToPdfmake = require("html-to-pdfmake");

export default function(
  title,
  inscriptions,
  is_bonification_list,
  is_homologation_list
) {
  let text = "";
  let htmlText = htmlToPdfmake(text);
  let inscriptionsListAux = inscriptions.map((e) => {
    if (e.id_ps === "61577ba4587b101cfd767233") {
      //
      e.vacancie = {
        title: e["Tipo de vaga"],
      };
    }
    // if (e.course.length) {
    //   let courseStr = "";
    //   for (let i = 0; i < e.course.length; i++) {
    //     const c = e.course[i];
    //     if (i !== e.course.length - 1) {
    //       courseStr += c.title + ", ";
    //     } else {
    //       courseStr += c.title;
    //     }
    //   }
    //   e.course = courseStr;
    // }
    return [
      {
        alignment: "center",
        text: e.inscriptionNumber,
      },
      {
        text: e.id_user.name,
      },
      {
        text: e.course,
      },
      {
        text:
          e.vacancie && e.vacancie.title
            ? e.vacancie.title
            : "Ampla Concorrência",
      },
      // {
      // 	text: e.bonification_accepted_subjudice ? 'DEFERIDO (sub judice)' : e.bonification_accepted ? 'DEFERIDA' : 'INDEFERIDA',
      // },
      // {
      // 	text: e.homologated_inscription ? 'HOMOLOGADA' : 'NÃO HOMOLOGADA',
      // },
    ];
  });
  if (is_bonification_list) {
    inscriptionsListAux.map((e) => {
      const inscriptionNumber = e[0].text;
      const index = inscriptions
        .map((i) => i.inscriptionNumber)
        .findIndex((i) => i === inscriptionNumber);
      e.push({
        text: inscriptions[index].bonification_accepted_subjudice
          ? "DEFERIDO (sub judice)"
          : inscriptions[index].bonification_accepted
          ? "DEFERIDA"
          : "INDEFERIDA",
      });
      return e;
    });
  }
  if (is_homologation_list) {
    inscriptionsListAux.map((e) => {
      const inscriptionNumber = e[0].text;
      const index = inscriptions
        .map((i) => i.inscriptionNumber)
        .findIndex((i) => i === inscriptionNumber);
      e.push({
        text: inscriptions[index].homologated_inscription?.status
          ? "HOMOLOGADA"
          : "NÃO HOMOLOGADA",
      });
      return e;
    });
  }
  // if (!is_bonification_list && !is_homologation_list)
  // 	inscriptionsListAux.map((e) => {
  // 		e.pop();
  // 		e.pop();
  // 		return e;
  // 	});
  let inscriptionsAux = {
    table: {
      headerRows: 1,
      body: [
        [
          { text: "N. Inscrição", alignment: "center", bold: true },
          { text: "Candidato", alignment: "center", bold: true },
          { text: "Curso Selecionado", alignment: "center", bold: true },
          { text: "Tipo de vaga", alignment: "center", bold: true },
        ],
        ...inscriptionsListAux,
      ],
      widths: [70, "*", "*", "*"],
    },
  };
  if (is_bonification_list) {
    inscriptionsAux.table.body[0].push({
      text: "Situação da bonificação",
      alignment: "center",
      bold: true,
    });
    inscriptionsAux.table.widths.push("*");
  }
  if (is_homologation_list) {
    inscriptionsAux.table.body[0].push({
      text: "Situação da inscrição",
      alignment: "center",
      bold: true,
    });
    inscriptionsAux.table.widths.push("*");
  }

  let inscriptionsPage = {
    // pageBreak: "before",
    columns: [
      {
        stack: [
          {
            alignment: "center",
            text: title,
            bold: true,
          },
          inscriptionsAux,
        ],
      },
    ],
  };
  htmlText.push(inscriptionsPage);

  let doc = { content: htmlText };
  doc.pageOrientation = "landscape";
  doc.pageMargins = [40, 100, 40, 60];
  doc.header = {
    margin: 10,
    alignment: "center",
    columns: [
      [
        {
          width: 20,
          image: unifapImage,
        },
        { text: "MINISTÉRIO DA EDUCAÇÃO", bold: true },
        { text: "UNIVERSIDADE FEDERAL DO AMAPÁ", bold: true },
        {
          text:
            "Rod. Juscelino Kubitschek Km 2, Jardim Marco Zero – Macapá-AP, CEP 68.903-419 www.unifap.br",
          fontSize: 8,
        },
      ],
    ],
  };
  pdfMake.createPdf(doc).download(`${title}.pdf`);
}
